import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { Chip, Paper, styled } from '@mui/material';
import Link from 'components/Link';
import MediaTypography from 'components/MediaTypography';

export const ProgramItemLink = styled(Link)({
	textDecoration: 'none',
});

export const ProgramItemWrap = styled(Paper)(({ theme }) => ({
	boxShadow: '0px 0px 30px 0px #827D8326',
	borderRadius: '30px',
	padding: '16px',
	display: 'flex',
	flexDirection: 'column',
	gap: '16px',
	transition: 'all .3s',
	position: 'relative',
	height: '100%',

	'&:hover': {
		boxShadow: '0px 0px 30px 0px #827D8380',
		'& h2': {
			color: theme.palette.primary.main,
		},
	},
}));

export const ProgramItemImage = styled('img')({
	maxWidth: '100%',
	width: '100%',
	objectFit: 'cover',
	borderRadius: '20px',
	aspectRatio: '16 / 9',
});

export const ImageWrapper = styled('div', {
	shouldForwardProp: (prop) => prop !== 'hasError',
})<{ hasError?: boolean }>(({ hasError = false }) => ({
	position: hasError ? 'static' : 'relative',
}));

export const Overlay = styled('div', {
	shouldForwardProp: (prop) => prop !== 'hasError',
})<{ hasError?: boolean }>(({ hasError = false }) => ({
	position: 'absolute',
	inset: 0,
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	borderRadius: '20px',
	background: 'rgba(21, 33, 62, 0.8)',

	...(!hasError
		? {
				aspectRatio: '16 / 9',
			}
		: {}),
}));

export const StyledLockIcon = styled(LockOutlinedIcon, {
	shouldForwardProp: (prop) => prop !== 'hasError',
})<{ hasError?: boolean }>(({ hasError = false, theme }) => ({
	width: hasError ? '50px' : '100px',
	height: hasError ? '50px' : '100px',
	color: theme.palette.primary.main,
}));

export const ProgramItemInfo = styled('div')({
	display: 'flex',
	flexDirection: 'column',
});

export const ProgramItemInfoTitle = styled(MediaTypography)(({ theme }) => ({
	transition: 'all .3s',

	[theme.breakpoints.down('sm')]: {
		marginTop: '4px',
	},
}));

export const ProgramItemInfoSubTitle = styled('p')(({ theme }) => ({
	fontSize: '14px',
	fontWeight: 700,
	lineHeight: '22px',
	letterSpacing: '0.1px',
	color: theme.palette.text.subTitle,
	margin: 0,
}));

export const StyledProgramItemDeadline = styled(Chip)({
	padding: '4px 8px',
	width: 'fit-content',
});
